/**
 * Example usage:
 *
 * import {AuditService} from '@utils'
 *
 * const AuditHelper = new AuditService(
 *     API,
 *     'audit-service',
 *     'log'
 * )
 *
 * AuditHelper.log(
 *     'companies',
 *     'update',
 *     'Company ID: 2',
 *     {
 *         id: 2,
 *         phone_old: '05554',
 *         phone_new: '41245'
 *     }
 * )
 */
export default class AuditService
{
    constructor( APIService, apiName, apiMethod = null, onError = null )
    {
        // APIService instance
        this.API = APIService
        if( this.API === undefined && window.API !== undefined ) {
            this.API = window.API
        }
        if( this.API === undefined ) {
            throw new Error('[AuditService] Please provide valid ApiService instance.')
        }

        // other
        this.apiName = apiName
        this.apiMethod = apiMethod
        this.onError = (null !== onError && onError !== undefined) ? onError : function(){}
    }

    log(
        page = null,
        action = null,
        target = null,
        data = {}
    ) {
        let params = {
            page,
            action,
            target,
            data
        }

        return this.API.POST(
            this.apiName,
            this.apiMethod,
            params,
            { // options
                // do not show loaders
                onBeforeRequest() {},
                onAfterRequest() {},
                // do not show flash messages
                onErrorNotifyCallback() {}
            }
        ).then( response => {
            if( response.getStatus() !== response.constructor.STATUS_SUCCESS ) {
                this.onError(params)
            }
        }).catch( e => {
            this.onError(params)
        })
    }
}
